/*
 * This "manager" will select the required environment scopes based on an environment variable value.
 * It's currently cheap and dirty in that it's a basic if-else instead of something switchy, etc.
 */

const getEnvironmentScopes = () => ({
  apiRoles: {
    // endpoint: "http://localhost:5000/getRoles",
    scopes: [
      `https://${import.meta.env.VITE_AZURE_AD_B2C_TENANT_POLICY_URL}/${import.meta.env.VITE_SPA_TEST_READ_SCOPE}`
    ]
  },
  auditWebApi: {
    endpoint: `${import.meta.env.VITE_AUDIT_WEBAPI_ENDPOINT}`,
    scopes: [
      `https://${import.meta.env.VITE_AZURE_AD_B2C_TENANT_POLICY_URL}/${import.meta.env.VITE_SIGNEDIN_ACCESS_SCOPE}`
    ]
  },
  onboardingWebApi: {
    endpoint: `${import.meta.env.VITE_ONBOARDING_WEBAPI_ENDPOINT}`,
    scopes: [
      `https://${import.meta.env.VITE_AZURE_AD_B2C_TENANT_POLICY_URL}/${import.meta.env.VITE_SIGNEDIN_ACCESS_SCOPE}`
    ]
  },
  bbbeewebApi: {
    endpoint: `${import.meta.env.VITE_BBBEE_WEBAPI_ENDPOINT}`,
    scopes: [
      `https://${import.meta.env.VITE_AZURE_AD_B2C_TENANT_POLICY_URL}/${import.meta.env.VITE_SIGNEDIN_ACCESS_SCOPE}`
    ]
  },
  companyApi: {
    endpoint: `${import.meta.env.VITE_COMPANY_WEBAPI_ENDPOINT}`,
    scopes: [
      `https://${import.meta.env.VITE_AZURE_AD_B2C_TENANT_POLICY_URL}/${import.meta.env.VITE_SIGNEDIN_ACCESS_SCOPE}`
    ]
  },
  complianceWebApi: {
    endpoint: `${import.meta.env.VITE_COMPLIANCE_WEBAPI_ENDPOINT}`,
    scopes: [
      `https://${import.meta.env.VITE_AZURE_AD_B2C_TENANT_POLICY_URL}/${import.meta.env.VITE_SIGNEDIN_ACCESS_SCOPE}`
    ]
  },
  netconnWebApi: {
    endpoint: `${import.meta.env.VITE_NETCONN_WEBAPI_ENDPOINT}`,
    scopes: [
      `https://${import.meta.env.VITE_AZURE_AD_B2C_TENANT_POLICY_URL}/${import.meta.env.VITE_SIGNEDIN_ACCESS_SCOPE}`
    ]
  },
  notificationsWebApi: {
    endpoint: `${import.meta.env.VITE_NOTIFICATIONS_WEPAPI_ENDPOINT}`,
    scopes: [
      `https://${import.meta.env.VITE_AZURE_AD_B2C_TENANT_POLICY_URL}/${import.meta.env.VITE_SIGNEDIN_ACCESS_SCOPE}`
    ]
  },
  cleanWebApi: {
    endpoint: `${import.meta.env.VITE_CLEAN_URL}`,
    scopes: [
      `https://${import.meta.env.VITE_AZURE_AD_B2C_TENANT_POLICY_URL}/${import.meta.env.VITE_SIGNEDIN_ACCESS_SCOPE}`
    ]
  },
  userManagementWebApi: {
    endpoint: `${import.meta.env.VITE_USER_MANAGEMENT_WEBAPI_ENDPOINT}`,
    scopes: [
      `https://${import.meta.env.VITE_AZURE_AD_B2C_TENANT_POLICY_URL}/${import.meta.env.VITE_SIGNEDIN_ACCESS_SCOPE}`
    ]
  },
  documentManagementWebApi: {
    endpoint: `${import.meta.env.VITE_DOCMAN_WEBAPI_ENDPOINT}`,
    scopes: [
      `https://${import.meta.env.VITE_AZURE_AD_B2C_TENANT_POLICY_URL}/${import.meta.env.VITE_SIGNEDIN_ACCESS_SCOPE}`
    ]
  },
  integrationGatewayApi: {
    endpoint: `${import.meta.env.VITE_INTEGRATION_GATEWAY_WEBAPI_ENDPOINT}`,
    scopes: [
      `https://${import.meta.env.VITE_AZURE_AD_B2C_TENANT_POLICY_URL}/${import.meta.env.VITE_SIGNEDIN_INTEGRATION_GATEWAY_ACCESS_SCOPE}`
    ]
  },
  // COI is secured (US-16 / #6718): controllers require the signed-in B2C
  // access token, same shared scope as the other services (backend binds
  // AzureAdB2C:Scopes = AADSignedInScopes).
  coiWebApi: {
    endpoint: `${import.meta.env.VITE_COI_WEBAPI_ENDPOINT}`,
    scopes: [
      `https://${import.meta.env.VITE_AZURE_AD_B2C_TENANT_POLICY_URL}/${import.meta.env.VITE_SIGNEDIN_ACCESS_SCOPE}`
    ]
  }
});

export default getEnvironmentScopes;
